<template>
  <v-app class="" v-if="isLoggedIn">
    <v-layout>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <need-assistant @click="onClickAssistant($event)" />
      </v-dialog>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="project mt-2">
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn flat class="white--text" @click="createProjectPage()"
              >create project</v-btn
            >
            <v-btn
              flat
              class="white--text"
              v-if="projectType == 2"
              @click="locationPage()"
              >Location</v-btn
            >
            <v-btn flat class="white--text" @click="back()">Question</v-btn>
            <v-btn
              flat
              class="white--text"
              v-if="projectType == 1"
              @click="budgetPage()"
              >Budget</v-btn
            >
            <v-btn
              flat
              class="white--text"
              v-if="projectType == 2"
              @click="locationBasedBudgetPage()"
              >Location Budget</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-container style="margin-top: 0px">
      <v-layout>
        <div class="btn">
          <v-snackbar
            v-model="snackbar"
            :right="x === 'right'"
            :timeout="timeout"
            color="red"
            :top="y === 'top'"
          >
            {{ errorMsg }}
            <v-btn color="black" flat @click="snackbar = false"> Close </v-btn>
          </v-snackbar>
        </div>
        <v-flex xs12>
          <v-card>
            <v-card-title class="project">
              <div class="white--text headline">
                <span class="headline">Project Settings</span>
              </div>
              <div class="red--text headline ml-2">
                <v-btn
                  color="white darken-1"
                  small
                  dark
                  class="no-upercase red--text"
                  @click="needAssistant"
                >
                  Need assistance
                </v-btn>
              </div>
            </v-card-title>
          </v-card>
          <v-card>
            <v-card-title class="" v-if="projectType == 1 || projectType == 2">
              <div class="">
                <span class="headline red--text">Dasher Category</span>
              </div>
            </v-card-title>
            <v-card-text v-if="projectType == 1 || projectType == 2">
              <v-layout wrap>
                <v-flex xs12 sm6 mr-2>
                  <v-select
                    v-model="projectSetting.dasher_category"
                    :items="indexData.dasher_categories"
                    item-text="name"
                    item-value="id"
                    box
                    label="Select Dasher Type"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
            <filtering-dasher
              class="mt-0"
              v-if="projectSetting.dasher_category == 1"
            />

            <assign-team
              :dasher_category_id="getDasherCategory()"
              v-if="
                projectSetting.dasher_category == 2 && checkTeamFeatureAccess()
              "
            />
            <div
              v-else-if="
                projectSetting.dasher_category == 2 && !checkTeamFeatureAccess()
              "
            >
              <v-card-text v-if="projectType != 3">
                <p class="subheading black--text">
                  You are not allowed to use team dasher feature.
                </p>
                <p>
                  <router-link to="/subscription-package">
                    <p>
                      click here to upgrade your subscription to premium or
                      corporate
                    </p>
                  </router-link>
                </p>
              </v-card-text>
            </div>
            <v-card-title class="mb-0" v-if="projectType == 3">
              <div class="">
                <span class="headline red--text mb-0">Agent</span>
              </div>
            </v-card-title>
            <v-card-text v-if="projectType == 3">
              <assign-agent-group />
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions
              v-if="
                projectSetting.dasher_category == 2 && !checkTeamFeatureAccess()
              "
            >
              <v-spacer></v-spacer>
              <button class="button" flat @click="back">Back</button>
              <v-btn class="button" flat @click="submit">Save & next</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import { NeedAssistant } from "@/components/index";
import FilteringDasher from "../../components/project/create-project/FilteringDasher";
import AssignAgentGroup from "../../components/project/create-project/AssignAgentGroup";
import AssignTeam from "../../components/project/create-project/AssignTeam";

export default {
  components: {
    NeedAssistant,
    FilteringDasher,
    AssignAgentGroup,
    AssignTeam,
  },
  data: () => ({
    apiUrl: "project-setting-data",
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    dialog: false,
    projectSetting: {
      project_id: null,
      dasher_category: null,
      dasher_categories: null,
    },

    defaultItem: {
      project_id: null,
      dasher_category: null,
      dasher_categories: null,
    },

    valid: true,
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "subscriptionData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    getTitle: function () {
      if (this.projectType != 3) {
        return "Team";
      }
      return "Agent";
    },
    projectType() {
      // console.log(this.indexData.project_data? this.indexData.project_data.project_type_id: null);
      return this.indexData.project_data
        ? this.indexData.project_data.project_type_id
        : null;
    },
    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  watch: {},

  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.projectSetting.project_id = project_id;
      this.$store.dispatch("indexData", [this.apiUrl, project_id]);
    },
    getDasherCategory() {
      return this.projectSetting.dasher_category;
    },
    checkTeamFeatureAccess() {
      if (this.subscriptionData.subscriptionPlan.package_id < 2) {
        return false;
      } else {
        return true;
      }
    },

    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    createProjectPage() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.$store.dispatch("indexDataAndRout", [
        "project-info",
        project_id,
        "/create-project-edit",
      ]);
    },

    back() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.$store.dispatch("indexDataAndRout", [
        "question-json",
        project_id,
        "/dynamic-question",
      ]);
    },

    needAssistant() {
      this.dialog = true;
    },
    onClickAssistant(event) {
      if (event == 1) {
        this.dialog = false;
        this.snackbar = true;
        this.close;
      } else {
        this.dialog = false;
      }
    },

    submit() {
      // alert("ok");
      this.$store.dispatch("storeOrUpdateTeamAssignment", [
        "store-project-setting",
        this.projectSetting,
      ]);
      this.snackbar = true;
      this.close();
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 30px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
.no-upercase {
  text-transform: unset !important;
}
</style>
